import {observer} from "mobx-react";
import {ScrollTable} from "../../ui";
import {displayShipmentType} from "../../../api";
import {ShippingListItemDto} from "../../../api/kpi";

interface ShippingTableProps {
    data: ShippingListItemDto[]
}

const ShippingTable = observer(function ShippingTable({data}: ShippingTableProps) {
    return <>

        <div style={{
            paddingBottom: '1em',
            display: 'flex',
            flex: 1
        }}>
            <ScrollTable>
                <thead>
                <tr>
                    <th>Datum</th>
                    <th>Anzahl</th>
                    <th>Versandart</th>
                </tr>
                </thead>
                <tbody>
                {data.map(e => (
                    <tr key={`${e.shipmentType}+${e.date}`}>
                        <td>{(new Date(e.date)).toLocaleDateString('de')}</td>
                        <td>{e.count}</td>
                        <td>{displayShipmentType(e.shipmentType)}</td>
                    </tr>
                ))}
                </tbody>

            </ScrollTable>
        </div>
    </>
})

export {
    ShippingTable
}
